<template>
    <div>
      <base-navigation></base-navigation>
  
      <div class="dashboard">
        <header>
            <h5>Welcome {{ user.names}}</h5>
           
        </header>
  
      
  
        <div  v-if="filteredCampaigns.length" class="">
          <div
            v-for="campaign in filteredCampaigns"
            :key="campaign.id"
            class="card cards-container campaigns-container campaign-card"
          >
            <h3 class="card-title">{{ campaign.name }}</h3>
            <div class="card-details">
              <p class="card-description">
              <strong>Money Collected:</strong>
              {{ formatCurrency(campaign.amount_contributed) }}
            </p>
            <p>
              <strong>Expenditure:</strong>
              {{ formatCurrency(campaign.total_expenses) }}
            </p>
            <p>
              <strong>Remaining Balance:</strong>
              {{
                formatCurrency(
                  campaign.amount_contributed - campaign.total_expenses
                )
              }}
            </p>
  
            </div>
        
            <!-- <canvas :id="'chart-' + campaign.id"></canvas> -->
  
            <router-link class="copy-button" :to="`/campaign/${campaign.paybill_account}`">
              View
            </router-link>
          </div>
        </div>
  
        <div v-else class="no-campaigns">
          <p>No fundraising campaigns yet. Start by creating a new one!</p>
        </div>
  
        <!-- Modal for New Campaign Creation -->
        <div v-if="showNewCampaignModal" class="modal-overlay">
          <div class="modal-content">
            <h3>Create New Campaign</h3>
            <input
              v-model="newCampaign.name"
              placeholder="Campaign Name"
              type="text"
            />
            <button @click="addNewCampaign">Create</button>
            <button @click="closeNewCampaignModal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Chart } from "chart.js";
  
  export default {
    data() {
      return {
       
        showNewCampaignModal: false,
        newCampaign: {
          name: "",
        },
      };
    },
  
    created() {
      this.$store.dispatch("LoadCampaigns");
  
      try {
      const userData = localStorage.getItem("user");
      this.user = userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
    }
    },
    methods: {
      goTocampaign() {
        this.$router.push("/new/campaign");
      },
      formatCurrency(amount) {
        return new Intl.NumberFormat("en-KE", {
          style: "currency",
          currency: "KES",
        }).format(amount);
      },
      initCampaignChart(campaign) {
        const ctx = document
          .getElementById("chart-" + campaign.id)
          .getContext("2d");
        new Chart(ctx, {
          type: "doughnut",
          data: {
            labels: ["Collected", "Expenditure"],
            datasets: [
              {
                data: [campaign.collected, campaign.expenditure],
                backgroundColor: ["#007bff", "#dc3545"],
              },
            ],
          },
        });
      },
      openNewCampaignModal() {
        this.showNewCampaignModal = true;
      },
      closeNewCampaignModal() {
        this.showNewCampaignModal = false;
        this.newCampaign.name = "";
      },
      addNewCampaign() {
        if (this.newCampaign.name.trim()) {
          const newCampaign = {
            id: this.campaigns.length + 1,
            name: this.newCampaign.name,
            collected: 0,
            expenditure: 0,
          };
          this.campaigns.push(newCampaign);
          this.showNewCampaignModal = false;
          this.initCampaignChart(newCampaign);
        }
      },
    },
    computed: {
      collections() {
        return this.$store.getters.collections; //.filter(process=>process.processed =='0')
      },
  
      allCampaigns() {
        return this.$store.getters.allCampaigns; //.filter(c=>c.client_id ==7)
      },
      loggedInUser() {
        const user = localStorage.getItem("user");
        return user ? JSON.parse(user) : null;
      },
  
      filteredCampaigns() {
        return this.allCampaigns.filter((c) => c.client_id == this.user.id); //.toLowerCase().includes(this.search.toLowerCase())| client.id_number.toString().includes(this.search.toLowerCase())).slice(0,5)
        //return this.students.filter((student)=>student.student_name.toLowerCase().includes(this.search.toLowerCase()))).slice(0,5)
      },
    },
  };
  </script>
  
  <style scoped>
  .cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
}

@media (min-width: 768px) {
  .cards-container {
    grid-template-columns: repeat(2, 1fr); /* 2 cards for tablets */
  }
}

@media (min-width: 1024px) {
  .cards-container {
    grid-template-columns: repeat(3, 1fr); /* 3 cards for desktops */
  }
}

@media (min-width: 1440px) {
  .cards-container {
    grid-template-columns: repeat(4, 1fr); /* 4 cards for large screens */
  }
}

  .dashboard {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .new-campaign-btn {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .campaigns-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  
  .campaign-card {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    width: calc(50% - 20px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .campaign-card h3 {
    margin-bottom: 10px;
  }
  
  .no-campaigns {
    text-align: center;
    padding: 20px;
    background-color: #fff3cd;
    border-radius: 8px;
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
  }
  
  .modal-content input {
    margin-bottom: 15px;
    padding: 10px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .modal-content button {
    margin: 5px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .modal-content button:first-child {
    background-color: #007bff;
    color: white;
  }
  
  .modal-content button:last-child {
    background-color: #dc3545;
    color: white;
  }
  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    padding: 20px;
  }
  
  
   .card {
      background: linear-gradient(145deg, #ffffff, #f1f1f1);
      border-radius: 10px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      padding: 20px;
      width: 350px;
      margin: auto;
      text-align: center;
      transition: transform 0.3s, box-shadow 0.3s;
    }
    
    .card:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
    }
    
    .card-title {
      font-size: 1.8rem;
      color: #2a9d8f;
      margin-bottom: 10px;
      font-weight: bold;
    }
    
    .card-description {
      font-size: 1rem;
      color: #555;
      margin-bottom: 15px;
    }
    
    .card-details {
      font-size: 0.9rem;
      color: #333;
      margin-bottom: 15px;
    }
    
    .card-details p {
      margin: 5px 0;
    }
    
    .copy-button {
      background: #e63946;
      color: white;
      border: none;
      border-radius: 5px;
      padding: 10px 15px;
      cursor: pointer;
      font-size: 0.9rem;
      transition: background 0.3s, transform 0.2s;
    }
    
    .copy-button:hover {
      background: #c81c30;
      transform: scale(1.05);
    }
  </style>